document.querySelector("html").classList.add("js")

function badgeReviews() {
  return {
    visible: true,
    lastScrollY: window.scrollY,
    init() {
      window.addEventListener("scroll", () => {
        const currentScrollY = window.scrollY
        if (currentScrollY < this.lastScrollY) {
          this.visible = true
        } else if (currentScrollY > this.lastScrollY) {
          this.visible = false
        }

        this.lastScrollY = currentScrollY
      })
    },
  }
}

async function updateBasketCount(count = null) {
  try {
    let itemCount = count
    if (itemCount === null) {
      const res = await fetch("/cart.js")
      const cart = await res.json()
      itemCount = cart.item_count
    }
    const countBadge = document.getElementById("header-basket-count")
    if (countBadge) {
      countBadge.innerText = itemCount
      countBadge.closest(".header__cart-quantity")?.classList.toggle("hidden", itemCount === 0)
    }
  } catch (err) {
    console.error("Failed to update cart count:", err)
  }
}

if (!customElements.get("buy-button")) {
  class BuyButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector("button")
      this.variantInput = this.querySelector("input[type='hidden'][name='id'], input#product-variant-id")
      this.snippet = this.dataset.snippet || "basket-preview"
      this.init()
    }

    init() {
      if (!this.button || !this.variantInput) return
      this.button.addEventListener("click", () => this.addToCart())
    }

    async addToCart() {
      const variantId = this.variantInput.value
      if (!variantId) return
      this.setLoading(true)
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
        if (!res.ok) throw new Error("Add to cart failed")
        const data = await res.json()
        await updateBasketCount()
        this.refreshDrawer()
        requestAnimationFrame(() => {
          if (typeof bindCrossSellingEvents === "function") {
            bindCrossSellingEvents()
          }
        })
        setTimeout(() => {
          document.body.classList.add("basket-preview-active")
        }, 300)
      } catch (err) {
        console.error("Add to cart failed:", err)
      } finally {
        this.setLoading(false)
      }
    }

    refreshDrawer() {
      fetch(`${window.location.pathname}?snippet=${this.snippet}`)
        .then((res) => res.text())
        .then((html) => {
          const newHTML = new DOMParser().parseFromString(html, "text/html")
          const newWrapper = newHTML.querySelector("basket-preview")
          if (!newWrapper) return
          const oldBasket = document.querySelector("basket-preview")
          if (!oldBasket) return
          const newBasket = document.createElement("basket-preview")
          newBasket.innerHTML = newWrapper.innerHTML
          newBasket.dataset.endpoint = oldBasket.dataset.endpoint || "/cart"
          newBasket.dataset.snippet = oldBasket.dataset.snippet || "basket-preview"
          oldBasket.replaceWith(newBasket)
        })
        .catch((err) => console.error("Basket preview update failed:", err))
    }

    setLoading(state) {
      this.button.disabled = state
      this.button.classList.toggle("opacity-50", state)
      this.button.classList.toggle("cursor-not-allowed", state)
    }
  }
  customElements.define("buy-button", BuyButton)
}

if (!customElements.get("basket-preview")) {
  class BasketPreview extends HTMLElement {
    connectedCallback() {
      this.endpoint = this.dataset.endpoint || "/cart"
      this.snippet = this.dataset.snippet || "basket-preview"
      this.loadEvents()
      this.bindGlobalClose()
    }

    loadEvents() {
      this.querySelectorAll("[data-line-index]").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault()
          if (btn.disabled) return
          const line = parseInt(btn.dataset.lineIndex)
          const qty = btn.dataset.newQty ? parseInt(btn.dataset.newQty) : 0
          if (isNaN(line)) return
          this.setLoading(btn, true)
          fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ line, quantity: qty }),
          })
            .then(async (res) => {
              if (!res.ok) {
                const error = await res.json()
                this.displayError(error.message || "Something went wrong updating your cart.")
                this.setLoading(btn, false)
                return
              }
              this.refreshDrawer()
            })
            .catch((err) => {
              console.error("Cart update failed:", err)
              this.setLoading(btn, false)
            })
        })
      })
    }

    displayError(message) {
      const errorContainer = document.querySelector("#basket-preview-error")
      if (errorContainer) {
        errorContainer.textContent = message
        errorContainer.classList.remove("hidden")
        setTimeout(() => {
          errorContainer.classList.add("hidden")
          errorContainer.textContent = ""
        }, 5000)
      }
    }

    bindGlobalClose() {
      const closeBtn = this.querySelector("#basket-preview-close-btn")
      const overlay = this.querySelector("#basket-preview-overlay")
      if (closeBtn) {
        closeBtn.addEventListener("click", () => this.close())
      }
      if (overlay) {
        overlay.addEventListener("click", () => this.close())
      }
    }

    setLoading(btn, state) {
      btn.disabled = state
      btn.classList.toggle("opacity-50", state)
      btn.classList.toggle("cursor-not-allowed", state)
      btn.classList.toggle("cursor-pointer", !state)
    }

    refreshDrawer() {
      fetch(`${window.location.pathname}?snippet=${this.snippet}`)
        .then((res) => res.text())
        .then((html) => {
          const newHTML = new DOMParser().parseFromString(html, "text/html")
          const newWrapper = newHTML.querySelector("basket-preview")
          if (!newWrapper) return
          const newContent = document.createElement("basket-preview")
          newContent.innerHTML = newWrapper.innerHTML
          newContent.dataset.snippet = this.snippet
          newContent.dataset.endpoint = this.endpoint
          const itemCount = parseInt(newWrapper.dataset.count || "0")
          this.replaceWith(newContent)
          updateBasketCount(itemCount)
          requestAnimationFrame(() => {
            if (typeof bindCrossSellingEvents === "function") {
              bindCrossSellingEvents()
            }
          })
        })
        .catch((err) => console.error("Basket preview update failed:", err))
    }

    open() {
      document.body.classList.add("basket-preview-active")
    }

    close() {
      document.body.classList.remove("basket-preview-active")
    }
  }
  customElements.define("basket-preview", BasketPreview)
}

if (!customElements.get("basket-toggle")) {
  class BasketToggle extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector("#header-basket-btn")
      if (!btn) return
      btn.addEventListener("click", () => {
        document.body.classList.add("basket-preview-active")
      })
    }
  }
  customElements.define("basket-toggle", BasketToggle)
}

if (!customElements.get("geo-location")) {
  class GeoLocationModal extends HTMLElement {
    connectedCallback() {
      const modal = this.querySelector("#geoModal")
      const modalBox = this.querySelector("#geoModalBox")
      const closeBtn = this.querySelector("#closeGeoModal")
      const stayBtn = this.querySelector("#staysitebtn")
      const modalBody = this.querySelector("#modalBody")
      const flagImg = this.querySelector("#flag-icon")
      const redirectText = this.querySelector("#redirect-text")
      const redirectButton = this.querySelector("#redirect-btn")
      const currentSiteLang = this.getAttribute("current-lang")?.toLowerCase() || "en"
      const countryLangName = this.getAttribute("country-name") || "English"
      const languageNames = {
        de: "German",
        en: "English",
        fr: "French",
        nl: "Dutch",
        sv: "Swedish",
        no: "Norwegian",
        dk: "Danish",
        es: "Spanish",
        it: "Italian",
        pl: "Polish",
        cz: "Czech",
        us: "English",
        "pt-pt": "Portuguese",
      }
      const availableLanguages = Object.keys(languageNames).map((lang) => lang.toLowerCase())
      const setLocalStorage = (key, value) => localStorage.setItem(key, value)
      const getLocalStorage = (key) => localStorage.getItem(key)
      const shouldShowModal = () => {
        const lastShownDate = getLocalStorage("geoLocationModalShownDate")
        const currentDate = new Date().getTime()
        const daysSinceLastShown = lastShownDate ? (currentDate - lastShownDate) / (1000 * 3600 * 24) : null
        return !(getLocalStorage("geoLocationModalShown") && daysSinceLastShown < 3)
      }
      const showModal = (targetLang, targetLangName) => {
        modalBody.innerHTML = `
          The website is in ${countryLangName} language. Would you like to be redirected to our ${targetLangName} website for a better experience?
        `
        flagImg.src = `https://cdn.shopify.com/static/images/flags/${targetLang === "en" ? "us" : targetLang}.svg`
        flagImg.alt = targetLangName
        redirectText.innerHTML = `Redirect To ${targetLangName} Site`
        redirectButton.value = `${targetLang}`
        document.body.classList.add("geo-location-active")
        modal.classList.remove("opacity-0", "pointer-events-none")
        modal.classList.add("opacity-100")
        modalBox.classList.remove("opacity-0", "-translate-y-5")
        modalBox.classList.add("opacity-100", "translate-y-0")
        setLocalStorage("geoLocationModalShown", "true")
        setLocalStorage("geoLocationModalShownDate", new Date().getTime())
      }
      const closeModal = () => {
        document.body.classList.remove("geo-location-active")
        modal.classList.add("opacity-0")
        modalBox.classList.remove("opacity-100", "translate-y-0")
        modalBox.classList.add("opacity-0", "-translate-y-5")
        setTimeout(() => (modal.style.display = "none"), 300)
      }
      if (shouldShowModal()) {
        fetch("https://morgenland-cpanel.eu/api/morgenland-info")
          .then((res) => res.json())
          .then((data) => {
            const userLangCode = data.data.countryCode.toLowerCase()
            const isSupported = availableLanguages.includes(userLangCode)
            const targetLang = isSupported ? userLangCode : "en"
            const targetLangName = languageNames[targetLang] || "English"
            if (currentSiteLang !== targetLang) {
              setTimeout(() => {
                showModal(targetLang, targetLangName)
              }, 3000)
            }
          })
          .catch((err) => console.error("Geo fetch error:", err))
      }
      closeBtn.addEventListener("click", closeModal)
      stayBtn.addEventListener("click", closeModal)
      modal.addEventListener("click", (e) => {
        if (!modalBox.contains(e.target)) closeModal()
      })
    }
  }
  customElements.define("geo-location", GeoLocationModal)
}

if (!customElements.get("cross-sell-products")) {
  class CrossSellProducts extends HTMLElement {
    connectedCallback() {
      this.render()
      this.bindEvents()
    }
    render() {
      const template = document.getElementById("cross-sell-template")
      if (!template) return
      this.innerHTML = template.innerHTML
    }
    bindEvents() {
      this.querySelectorAll('select[name="variant_id"]').forEach((select) => {
        const productId = select.dataset.productId
        const variantsData = JSON.parse(select.dataset.variants.replace(/&quot;/g, '"'))
        const hiddenInput = this.querySelector(`#variant-id-${productId}`)
        const priceContainer = this.querySelector(`#price-${productId}`)
        select.addEventListener("change", (e) => {
          const selectedId = e.target.value
          const selectedVariant = variantsData.find((v) => v.id == selectedId)
          if (selectedVariant) {
            if (hiddenInput) hiddenInput.value = selectedVariant.id
            let html = '<div class="product-price flex items-center flex-wrap gap-2">'
            if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
              html += `<span class="text-primary-dark font-bold text-base">${Shopify.formatMoney(
                selectedVariant.price
              )}</span>`
              html += `<span class="text-neutral-500 line-through text-sm">${Shopify.formatMoney(
                selectedVariant.compare_at_price
              )}</span>`
            } else {
              html += `<span class="text-neutral-800 font-bold text-sm">${Shopify.formatMoney(
                selectedVariant.price
              )}</span>`
            }
            html += "</div>"
            if (priceContainer) priceContainer.innerHTML = html
          }
        })
      })
      this.querySelectorAll(".additional-product-btn").forEach((button) => {
        const formPresent = button.closest("form")
        if (formPresent) return
        const productId = button.dataset.productId
        const endpoint = button.dataset.endpoint || "/cart/add.js"
        const hiddenInput = this.querySelector(`#variant-id-${productId}`)
        button.addEventListener("click", async () => {
          if (!hiddenInput || !hiddenInput.value) return
          const variantId = hiddenInput.value
          button.disabled = true
          button.classList.add("opacity-50", "cursor-not-allowed")
          try {
            const res = await fetch(endpoint, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ id: variantId, quantity: 1 }),
            })
            if (!res.ok) throw new Error("Add to cart failed")
            const drawer = document.querySelector("basket-preview")
            if (drawer && typeof drawer.refreshDrawer === "function") {
              drawer.refreshDrawer()
              drawer.open?.()
            }
          } catch (err) {
            console.error(err)
          } finally {
            button.disabled = false
            button.classList.remove("opacity-50", "cursor-not-allowed")
          }
        })
      })
    }
  }
  customElements.define("cross-sell-products", CrossSellProducts)
}

// class BackToTop extends HTMLElement {
//   connectedCallback() {
//     const button = this.querySelector("#backToTop")
//     button.classList.add("hidden")
//     window.addEventListener("scroll", () => {
//       if (window.scrollY > 100) {
//         button.classList.remove("hidden")
//       } else {
//         button.classList.add("hidden")
//       }
//     })
//     button.addEventListener("click", () => {
//       window.scrollTo({ top: 0, behavior: "smooth" })
//     })
//   }
// }
// customElements.define("back-to-top", BackToTop)
